import { Flex, Grid, Text } from '@chakra-ui/react';
import { CameraIcon, CalendarDotsIcon, MapPinIcon, ShieldCheckIcon } from '@phosphor-icons/react';
import { CardTitle, Container, DisplayHeading, Eyebrow, Stamp, type CardArt } from '@/travo/components/ui/postmark';
import { useCopy } from '@/travo/i18n';
import { cycle } from '@/travo/utils/cycle';

/** Per-reason art, in the same order as copy.about.reasons. */
const REASON_ART: [CardArt, ...CardArt[]] = [
  { icon: MapPinIcon, color: 'sun', tilt: '-1deg' },
  { icon: CameraIcon, color: 'sky', tilt: '0.8deg' },
  { icon: CalendarDotsIcon, color: 'sand', tilt: '-0.6deg' },
  { icon: ShieldCheckIcon, color: 'sun', tilt: '1deg' }
];

const WhyTravo = () => {
  const { about } = useCopy();

  return (
    <Container as="section" pb={{ base: '80px', md: '112px' }}>
      <Flex wrap="wrap" align="flex-end" justify="space-between" gap="24px" mb="52px">
        <DisplayHeading fontSize={{ base: '34px', md: '54px' }}>{about.whyTitle}</DisplayHeading>
        <Text maxW="24em" color="inkSoft">
          {about.whyBody}
        </Text>
      </Flex>
      <Grid templateColumns="repeat(auto-fit, minmax(260px, 1fr))" gap="32px">
        {about.reasons.map((reason, i) => {
          const { icon: ReasonIcon, color: edge, tilt } = cycle(REASON_ART, i);
          return (
            <Stamp key={reason.title} edge={edge} frame="card" transform={`rotate(${tilt})`}>
              <Flex direction="column" gap="14px">
                <Flex justify="space-between" align="center">
                  <Eyebrow fontSize="12px" color="ink">
                    No. {String(i + 1).padStart(2, '0')}
                  </Eyebrow>
                  <ReasonIcon size={30} weight="duotone" aria-hidden />
                </Flex>
                <CardTitle>{reason.title}</CardTitle>
                <Text fontSize="16px" color="inkSoft">
                  {reason.body}
                </Text>
              </Flex>
            </Stamp>
          );
        })}
      </Grid>
    </Container>
  );
};

export default WhyTravo;
